// Interfaccia che definisce la struttura della risposta dei dati del veicolo
export interface IVehicleDataResponse {
    verifica?: boolean;
    messaggio?: string;
}

// Definizione del tipo di stato iniziale
// plate: memorizza targa tipo stringa;
// searchedPlate: memorizza targa ricercata, tipo stringa;
// plateLenError: memorizza messaggio di errore lunghezza targa digitata tipo stringa;
// vehicleType: memorizza tipo veicolo, tipo stringa;
// searchedType: memorizza tipo veicolo ricercato, tipo stringa;
// typeLenError: memorizza essaggio di errore tipo veicolo, tipo stringa;
// authCaptcha: memorizza captcha, stringa non vuota se validata, tipo stringa;
// vehicleData: dati di risposta della ricerca della targa tipo IVehicleDataResponse | undefined;
// vehicleDataSpinner: memorizza stato dello spinner, se in fase di ricerca e' visualizzato, tipo boolean;
// vehicleDataError: memorizza stato di errore della ricrca sulla targa tipo Error | undefined;
export type RevisioniState = {
    plate: string;
    searchedPlate: string;
    plateLenError : string;
    vehicleType: string;
    searchedType: string,
    typeLenError: string,
    authCaptcha: string;
    vehicleData: IVehicleDataResponse | undefined;
    vehicleDataSpinner: boolean;
    vehicleDataError: Error | undefined;
};

// Definizione del tipo di azioni
// "SET_PLATE" memorizza la targa in plate, accetta payload: string 
// "SET_SEARCHED_PLATE" memorizza la targa cercata in plsearchedPlateate, accetta payload: string 
// "SET_PLATE_LEN_ERROR" memorizza msg di errore targa digitata, accetta payload: string 
// "SET_TYPE" memorizza il tipo di veicolo in vehicleType, accetta payload: string 
// "SET_SEARCHED_TYPE" memorizza il tipo di veicolo cercato, accetta payload: string 
// "SET_TYPE_LEN_ERROR" memorizza msg di errore tipo di veicolo selezionato, accetta payload: string 
// "SET_AUTH_CAPTCHA" memorizza captcha, accetta payload: string
// "SET_VEHICLE_DATA" memorizza dati di risposta della ricerca della targa accetta payload: IVehicleDataResponse | undefined;
// "SET_VEHICLE_DATA_SPINNER memorizza stato dello spinner, se in fase di ricerca e' visualizzato, accetta payload: boolean;
// "SET_VEHICLE_DATA_ERROR" memorizza stato di errore della ricrca sulla targa accetta payload: Error | undefined;
type Action =
    | { type: "SET_PLATE"; payload: string }
    | { type: "SET_SEARCHED_PLATE"; payload: string }
    | { type: "SET_PLATE_LEN_ERROR"; payload: string }
    | { type: "SET_TYPE"; payload: string }
    | { type: "SET_SEARCHED_TYPE"; payload: string }
    | { type: "SET_TYPE_LEN_ERROR"; payload: string }
    | { type: "SET_AUTH_CAPTCHA"; payload: string }
    | { type: "SET_VEHICLE_DATA"; payload: IVehicleDataResponse | undefined }
    | { type: "SET_VEHICLE_DATA_SPINNER"; payload: boolean }
    | { type: "SET_VEHICLE_DATA_ERROR"; payload: Error | undefined };



// Reducer per gestire lo stato
// ad ogni azione che viene invocata con il dispatch 
// il reduced restituisce lo stato corrente ed il payload dell'azione
function revisioniReducer(state: RevisioniState, action: Action): RevisioniState {
    switch (action.type) {
        case "SET_PLATE":
            return {
                ...state,
                plate: action.payload,
            };
        case "SET_SEARCHED_PLATE":
            return {
                ...state,
                searchedPlate: action.payload,
            };
        case "SET_PLATE_LEN_ERROR":
            return {
                ...state,
                plateLenError: action.payload,
            };
        case "SET_TYPE":
            return {
                ...state,
                vehicleType: action.payload,
            };
        case "SET_SEARCHED_TYPE":
            return {
                ...state,
                searchedType: action.payload,
            };
        case "SET_TYPE_LEN_ERROR":
            return {
                ...state,
                typeLenError: action.payload,
            };
        case "SET_AUTH_CAPTCHA":
            return {
                ...state,
                authCaptcha: action.payload,
            };
        case "SET_VEHICLE_DATA":
            return {
                ...state,
                vehicleData: action.payload,
            };
        case "SET_VEHICLE_DATA_SPINNER":
            return {
                ...state,
                vehicleDataSpinner: action.payload,
            };
        case "SET_VEHICLE_DATA_ERROR":
            return {
                ...state,
                vehicleDataError: action.payload,
            };
        default:
            return state;
    }
}
export default revisioniReducer;
